import type { WishlistActionPermissionsViewModel, WishlistPermission } from '@nexus/customer/wishlists/model';

export function resolveWishlistActionPermissions(
  permissions: readonly WishlistPermission[],
): WishlistActionPermissionsViewModel {
  return {
    raw: permissions,
    canView: permissions.includes('wishlist.view'),
    canEditWishlist: permissions.includes('wishlist.edit'),
    canArchiveWishlist: permissions.includes('wishlist.archive'),
    canManageAccess: permissions.includes('wishlist.manage_access'),
    canAddItems: permissions.includes('item.add'),
    canEditItems: permissions.includes('item.edit'),
    canDeleteItems: permissions.includes('item.delete'),
    canCreateReservation: permissions.includes('reservation.create'),
    canViewReservationDetails: permissions.includes('reservation.view_details'),
    canCancelAnyReservation: permissions.includes('reservation.cancel_any'),
    canCancelOwnReservation: permissions.includes('reservation.cancel_own'),
  };
}
